module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "brownf"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("GRILLING BASICS FOR THE WEEKNIGHT COOK")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 2")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("THE GRILL PANTRY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 3")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("BEEF, BUFFALO + LAMB")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 4")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("PORK")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 5")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("SEAFOOD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 6")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("POULTRY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 7")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("VEGETABLES + VEGETARIAN MAIN COURSES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 8")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("TREASURED SIDES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 9")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("THE GRILL PLANNER—SECOND HELPINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("CHAPTER 10")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("FIRE-ROASTED FRUITS + OTHER SWEET TREATS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf3"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("SOURCES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf3"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf3"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/orangef.jpg"
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bluef1"
  }, [_c('strong', [_vm._v("TABLE OF EQUIVALENTS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0